import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ViewChild,
  AfterViewInit,
  ElementRef,
  HostListener,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromCommunityGrant from './state/community-grant.selectors';
import * as CommunityGrantAction from './state/community-grant.actions';
import * as fromAuth from '../../screens/login/state/login.selectors';
import * as lgeApp from 'src/app/state/app.actions';
import * as appConfig from 'src/app/app.constant';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DecimalPipe } from '@angular/common';
import {
  Router,
  ActivatedRoute,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { SignaturePad } from 'angular2-signaturepad';
import { saveAs } from 'file-saver';
import { slideInDownAnimation } from 'src/app/app.animation';
import { PreviousRouteService } from 'src/commons/services/previousRoute.service';
import { LoginRedirect } from '../login/state/login.actions';
import {
  AuthenticationService,
  ErrorParseService,
  ICommunityGrant,
  IExternalData,
  LGEDataService,
  PermissionsService,
} from 'src/commons';
import { AngularMaterialService } from 'src/commons/utilities/angular.material.service';
import {
  catchError,
  map,
  Observable,
  of,
  pairwise,
  skipWhile,
  Subscription,
} from 'rxjs';
import { MatSelectionListChange } from '@angular/material/list';
import { ExternalStatus } from 'src/app/app.constant';
declare let LGEKUFX;

@Component({
  selector: 'community-grant-screen',
  templateUrl: 'community-grant.component.html',
  styleUrls: ['community-grant.scss'],
  animations: [slideInDownAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommunityGrantScreenComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() private pending$: Observable<boolean>;
  private pendingSubscription: Subscription;
  private pending: boolean = true;
  @Input() private error$: Observable<string | null>;
  private errorSubscription: Subscription;
  private error: string | null;
  @Input() private stateData$: Observable<ICommunityGrant | null>;
  private stateDataSubscription: Subscription;
  private stateData: ICommunityGrant | null;
  @Input() private profileData$: Observable<IExternalData | null>;
  private profileDataSubscription: Subscription;
  private profileData: IExternalData | null;
  cgForm: FormGroup;
  serviceAreas = ['LG&E Service Area', 'KU Service Area', 'ODP Service Area'];
  states = appConfig.SHARE_ARRAYS.states;
  fundSources = [
    'Government',
    'United Way',
    'Fund for the Arts',
    'Corporate Donor',
    'Community Foundation',
    'Private Foundation',
    'National Organization',
    'None of These',
  ];
  catReqs = [
    'Arts',
    'Diversity',
    'Economic Development',
    'Education',
    'Environment',
    'Health and Human Services',
    'Other',
  ];
  hasOtherCatFund: boolean = false;
  hasOtherCatReq: boolean = false;
  isReadOnly: boolean = false;
  isShowLeaveDialog: boolean = false;
  formId;
  formData;
  isShowSaveAsDraft = false;
  isShowSaveButton = false;
  isShowAwardedAmount = false;
  isAwardedAmount = false;
  isAwardedAmountEditable = true;
  isTaxExemptEditable = false;

  numPipe = new DecimalPipe('en-Us');

  twoDecMask = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2,
    integerLimit: null,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: true,
  });

  oneDecMask = createNumberMask({
    prefix: '',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 1,
    integerLimit: null,
    requireDecimal: false,
    allowNegative: false,
    allowLeadingZeroes: true,
  });
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  signaturePadOptions: Object = {
    dotSize: 0.6,
    minWidth: 0.6,
    maxWidth: 1.2,
    canvasWidth: 400,
    canvasHeight: 160,
    throttle: 0,
    backgroundColor: 'rgba(238,238,238,1)',
  };
  isInternal: boolean = false;

  @ViewChild('fileInputTaxExempt') fileInputTaxExempt: ElementRef;
  @ViewChild('fileInputW9') fileInputW9: ElementRef;
  @ViewChild('fileInputBoD') fileInputBoD: ElementRef;
  @ViewChild('fileInputBudget') fileInputBudget: ElementRef;
  @ViewChild('fileInputAdditional') fileInputAdditional: ElementRef;
  fileId: String = '';
  TaxExemptAttachDeleted = this.fb.array([]);
  W9AttachDeleted = this.fb.array([]);
  BoDAttachDeleted = this.fb.array([]);
  BudgetAttachDeleted = this.fb.array([]);
  AddAttachDeleted = this.fb.array([]);
  attachId: Number = -1;
  isAccDistEditable: boolean = false;
  isShowAccDist: boolean = false;
  taxExemptList: any;
  isShowReassignBtn: boolean = false;
  isShowWithdrawBtn: boolean = false;
  isShowApproveBtn: boolean = false;
  isFormExpired: boolean = false;
  companyData: any = [];
  expTypeData: any = [];
  expOrgData: any = [];
  projectData: any = [];
  taskData: any = [];
  isADValid: boolean = false;
  ValidatingRow: number = 0;
  isValidatingRow = true;
  isFilled: boolean = false;

  @HostListener('window:beforeunload', ['$event'])
  handleClose($event) {
    if (this.isShowLeaveDialog) {
      return false;
    }
    return true;
  }

  constructor(
    private store: Store<fromCommunityGrant.State>,
    private storeAuth: Store<fromAuth.State>,
    private ref: ChangeDetectorRef,
    private fb: FormBuilder,
    private ams: AngularMaterialService,
    private permissionsService: PermissionsService,
    private _dataService: LGEDataService,
    private previousRouteService: PreviousRouteService,
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private errorParse: ErrorParseService
  ) {
    this.isInternal = this.permissionsService.isInternal();
    this.selectState();
    if (this.hasRole('ADMIN')) {
      this.taxExemptList = appConfig.SHARE_ARRAYS.taxExemptList;
    }
    this.createForms();
  }

  ngOnInit() {
    this.startSubscriptions();
    window.addEventListener('beforeunload', function () {
      return 'Dialog Text Here';
    });
  }

  ngAfterViewInit(): void {
    this.signaturePad.clear();
    this.route.params.subscribe((response) => {
      this.formId = parseInt(response['id']);
      if (this.formId) {
        this.checkFormExpired().subscribe({
          next: (result) => {
            // if (result === 'Expired' && !this.isInternal) {
            //     this.ams.showAlert('Expired', 'Community Grants Application has been expired!');
            //     this.ref.markForCheck();
            // }
            this.store.dispatch(
              new CommunityGrantAction.LoadCommunityGrantState(this.formId)
            );
          },
        });
      } else {
        setTimeout(() => {
          if (!this.isInternal) this.AutopopulateInfo();
          this.checkFormExpired().subscribe({
            next: (result) => {
              if (result === 'Expired' && !this.isInternal) {
                this.ams.showAlert(
                  'Expired',
                  'Community Grants Application has been expired!'
                );
                this.ref.markForCheck();
              }
            },
          });
          this.cgForm
            .get(['AuthorizedRep', 'date'])
            .setValue(moment().format('MM/DD/YYYY'));
          this.isShowLeaveDialog = !this.isInternal; // internal can't submit, so no need leave dialog
          this.isShowSaveAsDraft = !this.isInternal || this.hasRole('DEV');
          this.ams.closeDialog();
          this.ref.markForCheck();
        });
      }
    });
  }

  hasRole(role: string) {
    return this.permissionsService.hasRoles(role);
  }

  getTaxExemptStatus(value) {
    if (value === '') return 'Other';
    else if (isNaN(value) || +value === 0) {
      return value;
    } else {
      return `501(c)(${+value})`;
    }
  }

  canDeactivate(
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return true;
    // return from(this.sessionCheck()).pipe(
    //     exhaustMap(result => {
    //         if (result)
    //             return from(this.confirmDialog());
    //         else
    //             return of(true);
    //     })
    // )
  }

  private confirmDialog(): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.isShowLeaveDialog && this.cgForm.dirty) {
        this.ams.showConfirm(
          'Alert!',
          ' Are you sure you want to navigate away from this page? If you proceed, ALL of your changes will be lost. Press Yes to continue, or Cancel to stay on the current page.'
        );
        this.ams.confirm
          .afterClosed()
          .subscribe((ans) => resolve(ans === 'yes'));
      } else {
        resolve(true);
      }
    });
  }

  // private sessionCheck(): Observable<boolean> {
  //     // return new Promise(resolve => {
  //     return this.authService.validateSession(this.permissionsService.getCurrentSession())
  //             // .then((result) => {
  //             //     if (result)
  //             //         resolve(true)
  //             //     else
  //             //         resolve(false)
  //             // })
  //             // .catch(error => resolve(false))
  //     // })
  // }

  drawComplete() {
    let base64Raw = this.signaturePad.toDataURL('base64').toString();
    this.cgForm.get(['AuthorizedRep', 'signature']).setValue(base64Raw);
  }

  drawStart() {}

  drawClear() {
    this.cgForm.get(['AuthorizedRep', 'signature']).setValue('');
    this.cgForm.get(['AuthorizedRep', 'signature']).updateValueAndValidity();
    this.signaturePad.clear();
  }

  private checkFormExpired(): Observable<string> {
    if (
      this.hasRole(
        'ADMIN|CITAPPROVER|CITREVIEWER|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
      )
    ) {
      this.isFormExpired = false;
      return of('Open');
    } else {
      return this._dataService.GetActiveForm().pipe(
        map((data: any) => {
          this.isFormExpired = data.find((item) => item === 'CG') === undefined;
          this.isReadOnly = this.isReadOnly
            ? this.isReadOnly
            : this.isFormExpired;
          this.ref.markForCheck();
          if (this.isFormExpired) {
            this.signaturePad.off();
            this.isShowLeaveDialog = false;
            return 'Expired';
          } else {
            return 'Open';
          }
        }),
        catchError((error) => {
          this.ams.showAlert('Error!', 'Failed checking form expiration!');
          this.ref.markForCheck();
          return of('Error');
        })
      );
    }
  }

  private getAccountingDistributionData() {
    const accDistParaArray = ['COMPANY', 'EXP_TYPE', 'EXP_ORG'];
    accDistParaArray.forEach((para) =>
      this._dataService.AccDistInfo_GetActiveByName([para, 'CI']).subscribe({
        next: (data) => {
          if (data) {
            switch (para) {
              case 'COMPANY':
                for (let i = 0; i < 2; i++) {
                  this.companyData.push(data);
                }
                this.ref.markForCheck();
                break;
              case 'EXP_TYPE':
                for (let i = 0; i < 2; i++) {
                  this.expTypeData.push(data);
                }
                this.ref.markForCheck();
                break;
              case 'EXP_ORG':
                for (let i = 0; i < 2; i++) {
                  this.expOrgData.push(data);
                }
                this.ref.markForCheck();
                break;
            }
          }
        },
        error: (error) => {
          this.ams.showAlert(
            'Error!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
          );
          this.ref.markForCheck();
        },
      })
    );
  }

  private getProjectTaskData() {
    this._dataService
      .ProjectTaskInfo_GetActiveByName(['PROJ_TASK_PLUS', 'CI'])
      .subscribe({
        next: (data) => {
          if (data) {
            for (let i = 0; i < 2; i++) {
              this.projectData.push(_.uniqBy(data, 'project'));
              this.taskData.push(_.uniqBy(data, 'task'));
            }
            this.ref.markForCheck();
          }
        },
        error: (error) => {
          this.ams.showAlert(
            'Error!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
          );
          this.ref.markForCheck();
          return of(error);
        },
      });
  }

  // Select state
  private selectState(): void {
    if (!this.isInternal) {
      this.profileData$ = this.storeAuth
        .select(fromAuth.getExternalProfile)
        .pipe(
          skipWhile(
            (stateData) => stateData === undefined || stateData === null
          )
        );
    }
    this.pending$ = this.store.select(
      fromCommunityGrant.getCommunityGrantScreenPending
    );
    this.stateData$ = this.store
      .select(fromCommunityGrant.getCommunityGrantState)
      .pipe(
        skipWhile((stateData) => stateData === undefined || stateData === null)
      );
    this.error$ = this.store
      .select(fromCommunityGrant.getCommunityGrantScreenError)
      .pipe(
        skipWhile(
          (error) => error === undefined || error === null || error === ''
        )
      );
  }

  private displayLoader(pending: boolean): void {
    if (pending) {
      setTimeout(() => {
        this.ams.showLoader('Loading');
        this.ref.markForCheck();
      });
    } else {
      this.ams.closeDialog().then(() => {
        if (
          this.error !== null &&
          this.error !== undefined &&
          this.error !== ''
        ) {
          this.displayError(this.error);
        }
      });
    }
  }

  private displayError(error: any): void {
    let errorMessage;
    if (this.errorParse.foundKeyWord(error, 'CORPCOMMONWS')) {
      errorMessage = this.errorParse.translateCCError(error);
    } else {
      errorMessage = error instanceof Object ? error.message : error;
    }
    this.ams.showAlert('Loading Error', errorMessage);
    this.ams.alert.afterClosed().subscribe((result) => {
      this.store.dispatch(
        new CommunityGrantAction.CommunityGrantScreenErrorReset()
      );
    });
  }

  // Create reactive forms
  private createForms(): void {
    this.cgForm = this.fb.group({
      OrgContactInfo: this.fb.group({
        orgContactInfoId: [null],
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        phone: [
          '',
          [
            Validators.required,
            Validators.pattern(new RegExp(/^\d{3}-\d{3}-\d{4}/)),
          ],
        ],
        email: [
          '',
          [
            Validators.required,
            Validators.maxLength(254),
            Validators.pattern(
              new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
            ),
          ],
        ],
      }),
      OrgInfo: this.fb.group({
        orgInfoId: [null],
        name: ['', [Validators.required]],
        payToOption: ['No'],
        payTo: ['', Validators.maxLength(80)],
        EIN: [
          '',
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.pattern(new RegExp(/^\d{2}-\d{7}/)),
          ],
        ],
        address1: ['', [Validators.required, Validators.maxLength(35)]],
        address2: ['', [Validators.maxLength(35)]],
        city: ['', [Validators.required, Validators.maxLength(50)]],
        state: ['', Validators.required],
        zipCode: [
          '',
          [
            Validators.required,
            Validators.pattern(new RegExp(/^\d{5}(-?\d{4})?$/)),
          ],
        ],
        webAddress: [''],
        budget: ['', [Validators.required]],
        ftStaff: ['', [Validators.required]],
        ptStaff: ['', [Validators.required]],
        orgDesc: ['', [Validators.required]],
        president: ['', Validators.required],
        email: [
          '',
          [
            Validators.required,
            Validators.maxLength(254),
            Validators.pattern(
              new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
            ),
          ],
        ],
        subsection_501: [''],
      }),
      AccDistribution: this.fb.array([
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: [''],
          project: [''],
          task: [''],
          expType: [''],
          expOrg: [''],
          amount: [''],
        }),
        this.fb.group({
          accDistributionId: [null],
          formId: [null],
          company: [''],
          project: [''],
          task: [''],
          expType: [''],
          expOrg: [''],
          amount: [''],
        }),
      ]),
      AuthorizedRep: this.fb.group({
        authRepId: [null],
        name: ['', [Validators.required, Validators.maxLength(50)]],
        date: ['', [Validators.required]],
        signature: [''],
      }),
      W9Attach: this.fb.array([]),
      TaxExemptAttach: this.fb.array([]),
      BoDListAttach: this.fb.array([]),
      BudgetAttach: this.fb.array([]),
      AddAttach: this.fb.array([]),
      FormLogInfo: this.fb.group({
        formId: [null],
        formLogId: [null],
        effdt: [''],
        action: [''],
        comment: [''],
        empId: [''],
        empName: [''],
        empTypeForLog: [''],
        status: [''],
        title: [''],
      }),
      formId: [null],
      orgContactInfoId: [null],
      orgInfoId: [null],
      authRepId: [null],
      userId: [''],
      isNationalOrgAsc: ['No', Validators.required],
      isVolunteerProvided: ['No', Validators.required],
      nationalOrgAscDescr: [''],
      isMembership: ['No', Validators.required],
      fundSrc: [[], Validators.required],
      govFundSrc: [''],
      unitedFundSrc: [''],
      corpDonorFundSrc: [''],
      communityFundSrc: [''],
      privateFundSrc: [''],
      nationalFundSrc: [''],
      hasNewsletter: ['No', Validators.required],
      serviceArea: [[], Validators.required],
      categoryFunding: ['', Validators.required],
      categoryFundingOther: [''],
      categoryRequest: ['', Validators.required],
      categoryRequestOther: [''],
      empName: [''],
      projectName: ['', [Validators.required, Validators.maxLength(30)]],
      projectLocation: ['', Validators.required],
      projectDate: [''],
      projectCost: ['', Validators.required],
      requestedAmount: ['', Validators.required],
      projectSummary: ['', Validators.required],
      addProjectInfo: ['', Validators.required],
      companyList: this.fb.array([
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
        this.fb.group({
          companyId: [null],
          formId: [null],
          companyName: [''],
          contribution: [''],
        }),
      ]),
      communityNeed: ['', Validators.required],
      communityBenefit: ['', Validators.required],
      partnerships: ['', [Validators.required]],
      plans: ['', Validators.required],
      successAwardedDesc: ['', Validators.required],
      payment: ['CHECK', Validators.required],
      amount: [''],

      statusId: [null],
      statusDescr: [''],
      statusDescrAdmin: [''],
      requestName: [''],
      requestNo: [''],
      submittedDate: [new Date()],
      lastUpdatedDate: [''],
      lastUpdatedBy: [''],
      isCIWorkflow: [0],
      deleteIt: [''],
    });
    this.cgForm.get(['OrgInfo', 'name']).valueChanges.subscribe((value) => {
      let nameLength = value.length;
      if (nameLength > 80) {
        this.cgForm.get(['OrgInfo', 'payToOption']).setValue('yes');
        if (this.cgForm.get(['OrgInfo', 'payTo']).value.length === 0) {
          this.cgForm
            .get(['OrgInfo', 'payTo'])
            .setValue(value.substring(0, 80));
        }
        this.cgForm.get(['OrgInfo', 'name']).setValue(name);
      }
    });
    this.cgForm
      .get(['OrgInfo', 'payToOption'])
      .valueChanges.subscribe((value) => {
        let isPayTo = value === null ? false : value === 'Yes';
        if (isPayTo) {
          this.cgForm
            .get(['OrgInfo', 'payTo'])
            .setValidators([Validators.required]);
          this.cgForm.get(['OrgInfo', 'payTo']).updateValueAndValidity();
        } else {
          this.cgForm.get(['OrgInfo', 'payTo']).setValue('');
          this.cgForm.get(['OrgInfo', 'payTo']).setValidators([]);
          this.cgForm.get(['OrgInfo', 'payTo']).updateValueAndValidity();
        }
      });
    this.cgForm.get('isNationalOrgAsc').valueChanges.subscribe((value) => {
      let isNationalOrgAsc = value === null ? false : value === 'Yes';
      if (isNationalOrgAsc) {
        this.cgForm
          .get('nationalOrgAscDescr')
          .setValidators([Validators.required]);
        this.cgForm.get('nationalOrgAscDescr').updateValueAndValidity();
      } else {
        this.cgForm.get('nationalOrgAscDescr').setValue('');
        this.cgForm.get('nationalOrgAscDescr').setValidators([]);
        this.cgForm.get('nationalOrgAscDescr').updateValueAndValidity();
      }
    });
    this.cgForm.get('categoryFunding').valueChanges.subscribe((value) => {
      this.hasOtherCatFund = value === null ? false : value.includes('Other');
      if (!this.hasOtherCatFund) {
        this.cgForm.get('categoryFundingOther').setValue('');
        this.cgForm.get('categoryFundingOther').setValidators([]);
        this.cgForm.get('categoryFundingOther').updateValueAndValidity();
      } else {
        this.cgForm
          .get('categoryFundingOther')
          .setValidators([Validators.required]);
        this.cgForm.get('categoryFundingOther').updateValueAndValidity();
      }
    });
    this.cgForm.get('categoryRequest').valueChanges.subscribe((value) => {
      this.hasOtherCatReq = value === 'Other';
      if (!this.hasOtherCatReq) {
        this.cgForm.get('categoryRequestOther').setValue('');
        this.cgForm.get('categoryRequestOther').setValidators([]);
        this.cgForm.get('categoryRequestOther').updateValueAndValidity();
      } else {
        this.cgForm
          .get('categoryRequestOther')
          .setValidators([Validators.required]);
        this.cgForm.get('categoryRequestOther').updateValueAndValidity();
      }
    });

    this.cgForm.controls['AccDistribution'].valueChanges.subscribe((value) => {
      let adArray = this.cgForm.get('AccDistribution') as FormArray;
      this.isAwardedAmountEditable = !adArray.controls.some((ad) => {
        return +ad.value.amount !== 0;
      });
      const validateObj = value[this.ValidatingRow];
      if (validateObj !== undefined) {
        if (
          validateObj.company !== '' &&
          validateObj.project !== '' &&
          validateObj.task !== '' &&
          validateObj.expType !== '' &&
          validateObj.expOrg !== '' &&
          this.isValidatingRow
        ) {
          this.isValidatingRow = false;
          this.Validate_Project_Task(validateObj);
        }
        this.callValidateAPI();
      }
    });

    this.cgForm
      .get('fundSrc')
      .valueChanges.pipe(pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        // if selected new
        if (prev.length < next.length) {
          const selected = _.difference(next, prev)[0];
          const selectedCtrl: string = this.getFundSrcControlName(selected);
          if (selected == 'None of These') {
            this.cgForm.get('fundSrc').setValue(['None of These']);
            prev.forEach((previousSelection) => {
              const ctrl = this.getFundSrcControlName(previousSelection);
              this.cgForm.get(ctrl).setValue('');
              this.cgForm.get(ctrl).setValidators([]);
              this.cgForm.get(ctrl).updateValueAndValidity();
            });
          } else {
            // update validators for selections requires Donor List
            if (selectedCtrl != '') {
              this.cgForm
                .get(selectedCtrl)
                .setValidators([Validators.required]);
              this.cgForm.get(selectedCtrl).updateValueAndValidity();
            }
            // unselected None of These if there is other value
            if (prev.includes('None of These')) {
              next.splice(next.length - 1, 1);
              this.cgForm.get('fundSrc').setValue(next);
            }
          }
        }
        // if deselected
        else {
          const deselected = _.difference(prev, next);
          _.each(deselected, (deselection: string) => {
            const ctrl = this.getFundSrcControlName(deselection);

            this.cgForm.get(ctrl).setValue('');
            this.cgForm.get(ctrl).setValidators([]);
            this.cgForm.get(ctrl).updateValueAndValidity();
          });
        }
      });
    if (this.isInternal) {
      this.getAccountingDistributionData();
      this.getProjectTaskData();
    }
  }

  createAttachment(fileId, base64, name, size, type): FormGroup {
    return this.fb.group({
      attachId: [-1],
      formId: [-1],
      fileId: [fileId],
      attachString: [base64],
      attachName: [name],
      attachSize: [size],
      attachType: [type],
      deleteIt: [0],
    });
  }
  DownloadAllAttachFile() {
    if (this.formId) {
      const arrayAddAttach = this.cgForm.get('AddAttach') as FormArray;
      arrayAddAttach.controls.forEach((item) => {
        this.DownloadAttachFile('AddAttach', item.value.attachName);
      });
    }
  }

  DownloadAttachFile(attachType: string, fileName) {
    const attachments = this.cgForm.get(attachType) as FormArray;
    const file = attachments.controls.find((item) => {
      return item.value.attachName === fileName;
    });
    this.ams.showLoader('Downloading...');
    if (file.value.attachId !== -1) {
      this._dataService
        .DownloadAttachmentFileById(file.value.attachId, 'CG')
        .subscribe((response) => {
          saveAs(response, `${file.value.attachName}`);
          this.ams.closeDialog();
        });
    } else if (file.value.attachString !== '') {
      this.ams.closeDialog();
      const byteArray = new Uint8Array(
        atob(file.value.attachString)
          .split('')
          .map((char) => char.charCodeAt(0))
      );
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      saveAs(blob, `${file.value.attachName}`);
    } else {
      this.ams.showAlert(
        'Unable to download',
        `You must saved change(s) first to download ${fileName} file`
      );
    }
  }
  handleReaderForm(attachType: string, e) {
    let base64 = [];
    base64.push(btoa(e.target.result));
    this.cgForm.get([attachType, '0', 'attachString']).setValue(base64[0]);
    this.ref.markForCheck();
  }

  uploadToFileService(file, type): Promise<any> {
    return new Promise((resolve) => {
      this.ams.showLoader('Validating file...');
      let corpCommonSessionInfo =
        this.permissionsService.getCorpCommonSessionInfo();
      var getCorpCommonSessionInfo = function (callback) {
        callback(corpCommonSessionInfo);
      };
      LGEKUFX.registerCorpCommonSessionHandler(getCorpCommonSessionInfo);
      var upload = LGEKUFX.uploadFileSync(
        file,
        (error) => {
          this.ams.closeDialog();
          if (error.message.includes('Request failed to authenticate')) {
            this.ams.showAlert(
              'Session Timeout',
              'Your session has been expired due to inactivity.  Please click OK to log in again.'
            );
            this.ams.alert.afterClosed().subscribe(() => {
              this.storeAuth.dispatch(new LoginRedirect());
            });
            setTimeout(() => {
              this.storeAuth.dispatch(new LoginRedirect());
            }, 10000);
          } else {
            this.ams.showAlert(
              'Error',
              `Failed to validate ${
                file.name
              } file. Please try other file or try again later. \nStack Trace: ${JSON.stringify(
                error
              )}`
            );
          }
          resolve('Invalid');
        },
        (bytesUploaded, bytesTotal) => {},
        () => {
          const fileId = upload.getFileId();
          let tempAttach: any = {};

          tempAttach = this.createAttachment(fileId, '', '', '0', type);
          tempAttach.value.formId = -4;
          this._dataService
            .ImportFileFromFileService(tempAttach.value)
            .subscribe({
              next: (data) => {
                this.attachId = data;
                this.ams.closeDialog();
                this.ref.markForCheck();
                resolve('Valid');
              },
              error: (error) => {
                this.ams.closeDialog();
                this.ref.markForCheck();
                this.ams.showAlert(
                  'Error',
                  `Failed to validate ${
                    file.name
                  } file. Please try other file or try again later. \nStack Trace: ${JSON.stringify(
                    error
                  )}`
                );
                resolve('Invalid');
              },
            });
          // this._dataService.ImportFileFromFileService(tempAttach.value)
          //     .then((data) => {
          //         this.attachId = data;
          //         this.ams.closeDialog();
          //         this.ref.markForCheck();
          //         resolve('Valid');
          //     })
          //     .catch(error => {
          //         this.ams.closeDialog();
          //         this.ref.markForCheck();
          //         this.ams.showAlert('Error', `Failed to validate ${file.name} file. Please try other file or try again later. \nStack Trace: ${JSON.stringify(error)}`);
          //         resolve('Invalid');
          //     });
        }
      );
    });
  }
  removeAttach(type) {
    let AttachArray = this.cgForm.get(type) as FormArray;
    const length = AttachArray.length;
    for (let i = 0; i < length; i++) {
      let item = AttachArray.controls[0];
      AttachArray.removeAt(0);
      if (item.value.attachId !== -1) {
        item.value.deleteIt = 1;
        switch (type) {
          case 'W9Attach':
            this.W9AttachDeleted.push(item as FormControl);
            break;
          case 'TaxExemptAttach':
            this.TaxExemptAttachDeleted.push(item as FormControl);
            break;
          case 'BoDListAttach':
            this.BoDAttachDeleted.push(item as FormControl);
            break;
          case 'BudgetAttach':
            this.BudgetAttachDeleted.push(item as FormControl);
            break;
          case 'AddAttach':
            this.AddAttachDeleted.push(item as FormControl);
        }
      }
    }
  }

  onAttachFileChange(event, type: string) {
    if (event.target.files.length > 0) {
      if (event.target.files[0].type !== 'application/pdf') {
        this.clearInput(type);
        this.ams.showAlert(
          '',
          'Only PDF file is allowed, please choose another file'
        );
      } else {
        if (event.target.files[0].size > 10485760) {
          // max 10MB - 10485760
          this.clearInput(type);
          this.ams.showAlert(
            '',
            'Attachment size exceeds the allowable limit, please choose another file'
          );
        } else {
          this.fileId = '';
          if (this.isInternal) {
            if (this.cgForm.get([type, '0']) === null) {
              (<FormArray>this.cgForm.get(type)).push(
                this.createAttachment(
                  'NA',
                  '',
                  event.target.files[0].name,
                  event.target.files[0].size.toString(),
                  type
                )
              );
            } else {
              this.removeAttach(type);
              (<FormArray>this.cgForm.get(type)).push(
                this.createAttachment(
                  'NA',
                  '',
                  event.target.files[0].name,
                  event.target.files[0].size.toString(),
                  type
                )
              );
            }
            const reader = new FileReader();
            reader.onload = this.handleReaderForm.bind(this, type);
            reader.readAsBinaryString(event.target.files[0]);
          } else {
            if (this.cgForm.get(type).value.length > 1) this.removeAttach(type);
            let tempW9 = this.createAttachment(
              'NA',
              '',
              event.target.files[0].name,
              event.target.files[0].size.toString(),
              type
            );
            this.uploadToFileService(event.target.files[0], type).then(
              (result) => {
                if (result === 'Valid') {
                  tempW9.value.attachId = this.attachId;
                  if (this.cgForm.get([type, '0']) === null) {
                    (<FormArray>this.cgForm.get(type)).push(tempW9);
                  } else {
                    this.removeAttach(type);
                    (<FormArray>this.cgForm.get(type)).push(tempW9);
                  }
                  this.attachId = -1;
                  this.ref.markForCheck();
                }
              }
            );
          }
        }
      }
    }
  }

  resetFileInput(type) {
    this.removeAttach(type);
    switch (type) {
      case 'W9Attach':
        this.fileInputW9.nativeElement.value = '';
        break;
      case 'TaxExemptAttach':
        this.fileInputTaxExempt.nativeElement.value = '';
        break;
      case 'BoDListAttach':
        this.fileInputBoD.nativeElement.value = '';
        break;
      case 'BudgetAttach':
        this.fileInputBudget.nativeElement.value = '';
        break;
      case 'AddAttach':
        this.fileInputAdditional.nativeElement.value = '';
        break;
    }
  }

  onAddAttachFileChange(event) {
    let fileList = [];
    fileList = Array.from(event.target.files);
    if (fileList.length > 0) {
      if (fileList.length < 10) {
        let isPDFIndex = fileList.findIndex(
          (item) => item.type !== 'application/pdf'
        );
        if (isPDFIndex <= -1) {
          const newLength = fileList.length;
          const uploadedLength = this.cgForm.value.AddAttach.length;
          if (newLength + uploadedLength <= 10) {
            let uploadFileSize: number = 0;
            let currentFileSize: number = 0;
            let totalFileSize = 0;
            for (let i = 0; i < newLength; i++) {
              uploadFileSize += parseInt(fileList[i].size);
            }
            if (uploadedLength > 0) {
              for (let i = 0; i < uploadedLength; i++) {
                currentFileSize += parseInt(
                  this.cgForm.get(['AddAttach', i.toString(), 'attachSize'])
                    .value
                );
              }
            }
            totalFileSize = uploadFileSize + currentFileSize;
            if (totalFileSize < 10485760) {
              let current = fileList.map(function (item) {
                return item.name;
              });
              if (this.cgForm.value.AddAttach.length > 0) {
                let upload = this.cgForm.value.AddAttach.map(function (item) {
                  return item.attachName;
                });
                current = [...current, ...upload];
              }
              let isDuplicate = current.some(function (item, idx) {
                return current.indexOf(item) != idx;
              });

              if (!isDuplicate) {
                let AddArray = this.cgForm.get('AddAttach') as FormArray;
                for (let i = 0; i < fileList.length; i++) {
                  if (this.isInternal) {
                    let tempAddAttach = this.createAttachment(
                      'NA',
                      '',
                      fileList[i].name,
                      fileList[i].size.toString(),
                      'AddAttach'
                    );
                    const reader: any = new FileReader();
                    const self = this;
                    reader.onload = function (e) {
                      let base64 = [];
                      base64.push(btoa(e.target.result));
                      tempAddAttach.value.attachString = base64[0];
                      AddArray.push(tempAddAttach);
                      self.ref.markForCheck();
                    };
                    reader.readAsBinaryString(fileList[i]);
                  } else {
                    this.uploadToFileService(fileList[i], 'AddAttach').then(
                      (result) => {
                        if (result === 'Valid') {
                          let tempAddAttach = this.createAttachment(
                            'NA',
                            '',
                            fileList[i].name,
                            fileList[i].size.toString(),
                            'AddAttach'
                          );
                          tempAddAttach.value.attachId = this.attachId;
                          this.attachId = -1;
                          AddArray.push(tempAddAttach);
                          this.ref.markForCheck();
                        }
                      }
                    );
                  }
                  this.fileInputAdditional.nativeElement.value = '';
                  this.ref.markForCheck();
                }
              } else {
                this.ams.showAlert(
                  '',
                  'Some of the files are already attached'
                );
              }
            } else {
              this.ams.showAlert(
                '',
                'Attachment size exceeds the allowable limit, please remove some files'
              );
            }
          } else {
            this.fileInputAdditional.nativeElement.value = '';
            this.ams.showAlert(
              '',
              'Number of Attachments exceeds the allowable limit(10 files), please remove some files'
            );
          }
        } else {
          this.fileInputAdditional.nativeElement.value = '';
          this.ams.showAlert(
            '',
            'Only PDF files are allowed, please choose another file'
          );
        }
      } else {
        this.fileInputAdditional.nativeElement.value = '';
        this.ams.showAlert(
          '',
          'Number of Attachments exceeds the allowable limit(10 files), please remove some files'
        );
      }
    }
    this.ref.markForCheck();
  }

  clearInput(type: String) {
    switch (type) {
      case 'TaxExemptAttach':
        this.fileInputTaxExempt.nativeElement.value = '';
        break;
      case 'W9Attach':
        this.fileInputW9.nativeElement.value = '';
        break;
      case 'BoDListAttach':
        this.fileInputBoD.nativeElement.value = '';
        break;
      case 'BudgetAttach':
        this.fileInputBudget.nativeElement.value = '';
        break;
      case 'AddAttach':
        this.fileInputAdditional.nativeElement.value = '';
        break;
    }
  }

  removeAddFile(fileName) {
    let arrayAddAttach = this.cgForm.get('AddAttach') as FormArray;
    arrayAddAttach.controls.forEach((item, index) => {
      if (item.value.attachName === fileName) {
        arrayAddAttach.removeAt(index);
        if (item.value.attachId !== -1) {
          item.value.deleteIt = 1;
          this.AddAttachDeleted.push(item as FormControl);
        }
      }
    });
  }

  onAmountChange(value, index: number) {
    // let tempAmount = ""// =
    // if (value !== '' && value.includes('.')) {
    //   const dec = value.split('.')[1];
    //   if (dec == "00" || dec == "" || dec == "0") {
    //     tempAmount = value.split('.')[0];
    //   } else {
    //     tempAmount = this.numPipe.transform(+parseFloat(value).toFixed(2), '1.2-2').replace(/,/g, '');
    //   }
    // }
    // else {
    //   tempAmount = value;
    // }
    // this.cgForm.get(['AccDistribution', index.toString(), 'amount']).setValue(tempAmount);
  }

  calculateTotalAmount() {
    const projectDetails = this.cgForm.controls['AccDistribution'].value;
    let newTotalAmount = 0;
    projectDetails.forEach((project) => {
      let amount = project.amount;
      let newAmount;
      if (amount == undefined || amount == null || amount == '') {
        newAmount = 0;
      } else {
        newAmount = parseFloat(amount);
      }
      newTotalAmount += newAmount; //+(parseFloat(project.amount) || 0).toFixed(2);+
    });
    let temp = this.numPipe
      .transform(newTotalAmount.toFixed(2), '1.2-2')
      .replace(/,/g, '');
    temp = temp.split('.')[1] === '00' ? temp.split('.')[0] : temp;
    this.isAwardedAmountEditable = +temp === 0;
    this.cgForm.get('amount').setValue(temp);
  }

  populateCompany(value, index) {
    if (this.companyData[0] !== undefined) {
      if (index === 0) {
        const selectedComp = this.companyData[0].filter(
          (x) => x.code === value
        );
        let i = 1;
        for (i; i < 2; i++) {
          this.companyData[i] = selectedComp;
          this.cgForm
            .get(['AccDistribution', i.toString(), 'company'])
            .setValue('');
        }
      } else {
        if (this.cgForm.controls['AccDistribution'].value[0].company === '') {
          this.ams.showAlert('Error!', 'Please select company for first row!');
          this.cgForm
            .get(['AccDistribution', index.toString(), 'company'])
            .setValue('');
          return;
        }
      }
      this.ref.markForCheck();
    } else {
      this.populateCompany(value, index);
    }
  }

  onAccDistSelect(value, index: number, selectedData: string): void {
    if (value) {
      this.ValidatingRow = index;
      this.isValidatingRow = true;
      switch (selectedData) {
        case 'company':
          this.populateCompany(value, index);
          this.cgForm
            .get(['AccDistribution', index.toString(), 'project'])
            .setValue('');
          this.cgForm
            .get(['AccDistribution', index.toString(), 'task'])
            .setValue('');
          break;

        case 'project':
          this.cgForm
            .get(['AccDistribution', index.toString(), 'task'])
            .setValue('');
          break;
        case 'task':
          this.cgForm
            .get(['AccDistribution', index.toString(), 'expType'])
            .setValue('');
          this.cgForm
            .get(['AccDistribution', index.toString(), 'expOrg'])
            .setValue('');
          break;

        case 'expType':
          this.cgForm
            .get(['AccDistribution', index.toString(), 'expOrg'])
            .setValue('');
          break;
      }
    }
  }

  callValidateAPI() {
    for (let i = 0; i < 2; i++) {
      // 4 to this.accDistData.length
      const validateObj = this.cgForm.controls['AccDistribution'].value[i];
      if (
        validateObj.company !== '' &&
        validateObj.project !== '' &&
        validateObj.task !== '' &&
        validateObj.expType !== '' &&
        validateObj.expOrg !== '' &&
        validateObj.amount !== ''
      ) {
        this.isFilled = true;
      } else if (
        validateObj.company === '' &&
        validateObj.project === '' &&
        validateObj.task === '' &&
        validateObj.expType === '' &&
        validateObj.expOrg === '' &&
        validateObj.amount === ''
      ) {
        this.isFilled = true;
      } else {
        this.isFilled = false;
        break;
      }
    }
  }

  Validate_Project_Task(data) {
    let validateObj: any = {
      project: data.project,
      task: data.task,
      expenditureType: data.expType,
      expenditureOrg: data.expOrg,
      company: data.company,
    };
    let jsonData = JSON.stringify(validateObj);
    this.ams.showLoader('Validating...');
    if (this.hasRole('CITAPPROVER') || this.hasRole('ADMIN')) {
      this._dataService.Validate_Project_Task(jsonData).subscribe({
        next: (data) => {
          this.ams.closeDialog();
          if (data) {
            const validateResult = JSON.parse(data);
            this.isADValid =
              validateResult.statusCode === 'VALID' ? true : false;
            if (!this.isADValid) {
              this.ams.showAlert(
                validateResult.statusCode,
                validateResult.statusMessage
              );
            }
            this.ref.markForCheck();
          }
        },
        error: (error) => {
          this.ams.showAlert(
            'Error!',
            `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
          );
          this.ams.closeDialog();
          this.ref.markForCheck();
        },
      });
    } else {
      this.ams.closeDialog();
      this.isADValid = true;
      this.ref.markForCheck();
    }
  }

  // Opens sidenav if on mobile
  openSidenav(): void {
    this.store.dispatch(new lgeApp.OpenSidenav());
  }

  // onFundSrcChange(option: any) {
  //     let listSelected = this.cgForm.value.fundSrc;
  //     let ctrlName = this.getFundSrcControlName(option.source.selectedOptions.selected);
  //     if (ctrlName === 'None of These') {
  //         if (listSelected.length > 1)
  //             this.cgForm.get('fundSrc').setValue(['None of These']);
  //         _.each(listSelected, item => {
  //             let ctrl = this.getFundSrcControlName(item);
  //             if (item !== 'None of These' && ctrl !== '') {
  //                 this.cgForm.get(ctrl).setValue('');
  //                 this.cgForm.get(ctrl).setValidators([]);
  //                 this.cgForm.get(ctrl).updateValueAndValidity();
  //             }
  //         })
  //     }
  //     if (ctrlName !== '') {
  //         if (ctrlName) {
  //             this.cgForm.get(ctrlName).setValidators([Validators.required]);
  //             this.cgForm.get(ctrlName).updateValueAndValidity();
  //         } else {
  //             this.cgForm.get(ctrlName).setValue('');
  //             this.cgForm.get(ctrlName).setValidators([]);
  //             this.cgForm.get(ctrlName).markAsPristine();;
  //             this.cgForm.get(ctrlName).updateValueAndValidity();
  //         }
  //     }
  // }

  getFundSrcPlaceholder(src) {
    let placeholder = '';
    switch (src) {
      case 'Corporate Donor':
        placeholder = `Please list up to five primary Corporate donors`;
        break;
      default:
        placeholder = `Please list up to five primary ${src}
        donors`;
        break;
    }
    return placeholder;
  }

  getFundSrcControlName(srcName) {
    let control = '';
    switch (srcName) {
      case 'Government':
        control = 'govFundSrc';
        break;
      case 'United Way':
        control = 'unitedFundSrc';
        break;
      case 'Corporate Donor':
        control = 'corpDonorFundSrc';
        break;
      case 'Community Foundation':
        control = 'communityFundSrc';
        break;
      case 'Private Foundation':
        control = 'privateFundSrc';
        break;
      case 'National Organization':
        control = 'nationalFundSrc';
        break;
    }
    return control;
  }

  isShowFundSrcTextField(fundSrc): boolean {
    let result: boolean = false;
    if (this.getFundSrcControlName(fundSrc) !== '') {
      result = this.cgForm.get('fundSrc').value.includes(fundSrc);
    }
    return result;
  }

  AutopopulateInfo() {
    this.cgForm
      .get(['OrgInfo', 'name'])
      .setValue(this.profileData.orgInfoExt.name);
    this.cgForm
      .get(['OrgInfo', 'EIN'])
      .setValue(this.profileData.orgInfoExt.EIN);
    this.cgForm
      .get(['OrgInfo', 'address1'])
      .setValue(this.profileData.orgInfoExt.address1);
    this.cgForm
      .get(['OrgInfo', 'address2'])
      .setValue(this.profileData.orgInfoExt.address2);
    this.cgForm
      .get(['OrgInfo', 'city'])
      .setValue(this.profileData.orgInfoExt.city);
    this.cgForm
      .get(['OrgInfo', 'state'])
      .setValue(this.profileData.orgInfoExt.state);
    this.cgForm
      .get(['OrgInfo', 'zipCode'])
      .setValue(this.profileData.orgInfoExt.zipCode);
    this.cgForm
      .get(['OrgInfo', 'subsection_501'])
      .setValue(this.profileData.orgInfoExt.subsection_501);
    this.cgForm
      .get(['OrgContactInfo', 'firstName'])
      .setValue(this.profileData.orgContactInfoExt.firstName);
    this.cgForm
      .get(['OrgContactInfo', 'lastName'])
      .setValue(this.profileData.orgContactInfoExt.lastName);
    this.cgForm
      .get(['OrgContactInfo', 'phone'])
      .setValue(this.profileData.orgContactInfoExt.phone);
    this.cgForm
      .get(['OrgContactInfo', 'email'])
      .setValue(this.profileData.orgContactInfoExt.email);
  }

  //save form as draft
  onSaveAsDraft() {
    // this._dataService.setFormCCName(this.cgForm.get('projectName').value);
    this.ams.showConfirmation(
      `Are you sure you want to save as draft?`,
      'CG',
      this.cgForm.get('projectName').value,
      30
    );
    this.ams.confirmation.afterClosed().subscribe((result) => {
      if (result) {
        this.checkFormExpired().subscribe({
          next: (status) => {
            this.ams.closeDialog();
            this.ref.markForCheck();
            this.cgForm.get('submittedDate').setValue(new Date());
            this.cgForm.value.userId = this.permissionsService.getUserId();
            this.cgForm.value.requestName = result.formName;
            this.cgForm.value.projectName = result.formName;
            this.cgForm.value.statusId = 2;
            this.cgForm.value.deleteIt = 'false';
            this.cgForm.value.AddAttach.push(...this.AddAttachDeleted.value);
            this.cgForm.value.TaxExemptAttach.push(
              ...this.TaxExemptAttachDeleted.value
            );
            this.cgForm.value.W9Attach.push(...this.W9AttachDeleted.value);
            this.cgForm.value.BudgetAttach.push(
              ...this.BudgetAttachDeleted.value
            );
            this.cgForm.value.BoDListAttach.push(
              ...this.BoDAttachDeleted.value
            );

            this.ams.showLoader('Drafting...');
            this._dataService.formCGIUD(this.cgForm.value).subscribe({
              next: (response) => {
                this.ams.closeDialog();
                this.ref.markForCheck();
                if (response === 'error') {
                  this.ams.showAlert(
                    'Error!',
                    'Please try again or contact Admin for support !!!'
                  );
                } else {
                  this.isShowLeaveDialog = false;
                  if (status === 'Expired') {
                    this.ams.showAlert(
                      'Expired',
                      'The application has been expired !!!'
                    );
                  } else {
                    this.ams.showAlert('Success!', 'Successfully Drafted!');
                  }
                  this.ref.markForCheck();
                  let leaving = setTimeout(() => {
                    this.toHome();
                  }, 5000);
                  this.ams.alert.afterClosed().subscribe(() => {
                    this.toHome();
                    clearTimeout(leaving);
                  });
                }
              },
              error: (error) => {
                this.ams.closeDialog();
                this.ams.showAlert('Error!', error);
                return of(error);
              },
            });
            this._dataService.setFormCCName('');
          },
        });
      }
    });
  }

  onSubmit() {
    this.cgForm.get('fundSrc').setValidators([Validators.required]);
    this.cgForm.get('fundSrc').updateValueAndValidity();
    this.cgForm
      .get(['AuthorizedRep', 'signature'])
      .setValidators([Validators.required]);
    this.cgForm.get(['AuthorizedRep', 'signature']).updateValueAndValidity();
    if (this.cgForm.invalid)
      this.ams.showAlert(
        'Alert',
        'Please complete all required field(s) marked with an *'
      );
    else if (
      this.cgForm.value.TaxExemptAttach.length === 0 ||
      this.cgForm.value.W9Attach.length === 0 ||
      this.cgForm.value.BoDListAttach.length === 0 ||
      this.cgForm.value.BudgetAttach.length === 0
    ) {
      this.ams.showAlert(
        'Alert',
        'Please attach required PDF documents marked with an *'
      );
    } else if (!this.isFilled && this.cgForm.value.isCIWorkflow === 1) {
      this.ams.showAlert(
        'Alert',
        'Please fill missing field(s) on Accounting Distribution!'
      );
    } else if (!this.isADValid && this.cgForm.value.isCIWorkflow === 1) {
      this.ams.showAlert(
        'Alert',
        'Your Accounting Distribution combination is invalid!'
      );
    } else {
      // this._dataService.setFormCCName(this.cgForm.get('projectName').value);
      this.ams.showConfirmation(
        `Are you sure you want to ${
          this.isShowSaveAsDraft ? 'submit' : 'save'
        }?`,
        'CG',
        this.cgForm.get('projectName').value,
        30
      );
      this.ams.confirmation.afterClosed().subscribe((result) => {
        if (result && result.formName) {
          this.checkFormExpired().subscribe({
            next: (status) => {
              this.cgForm.get('requestName').setValue(result.formName);
              this.cgForm.get('projectName').setValue(result.formName);
              this.savingForm(status).subscribe({
                next: (result) => {
                  if (result !== 'error') {
                    this.ams.closeDialog();
                    this.ref.markForCheck();
                    this.isShowLeaveDialog = false;
                    if (status === 'Expired') {
                      this.ams.showAlert(
                        'Expired',
                        'The application has been expired !!!'
                      );
                    } else if (this.isShowSaveAsDraft) {
                      this.ams.showAlert('Success!', 'Successfully submitted!');
                    } else {
                      this.ams.showAlert('Success!', 'Successfully saved!');
                    }
                    this.ref.markForCheck();
                    let leaving = setTimeout(() => {
                      this.toHome();
                    }, 5000);
                    this.ams.alert.afterClosed().subscribe(() => {
                      this.toHome();
                      clearTimeout(leaving);
                    });
                  }
                },
              });
            },
          });
        }
      });
    }
  }

  onUpdateFormStatus() {
    this.cgForm.value.statusId =
      this.cgForm.value.statusDescr == 'Submitted' ? 3 : 11;
    this.onSubmit();
  }

  savingForm(status): Observable<any> {
    this.cgForm.value.deleteIt = 'false';
    if (
      this.cgForm.value.statusId === 2 ||
      this.cgForm.value.statusId === null
    ) {
      this.cgForm.get('statusId').setValue(status === 'Open' ? 1 : 2);
      this.cgForm.get('submittedDate').setValue(new Date());
      let userId = this.cgForm.value.userId;
      this.cgForm.value.userId =
        userId === '' ? this.permissionsService.getUserId() : userId;
    }
    this.cgForm.value.deleteIt = 'false';
    this.cgForm.value.AddAttach.push(...this.AddAttachDeleted.value);
    this.cgForm.value.TaxExemptAttach.push(
      ...this.TaxExemptAttachDeleted.value
    );
    this.cgForm.value.W9Attach.push(...this.W9AttachDeleted.value);
    this.cgForm.value.BudgetAttach.push(...this.BudgetAttachDeleted.value);
    this.cgForm.value.BoDListAttach.push(...this.BoDAttachDeleted.value);

    this.ams.showLoader(this.isShowSaveAsDraft ? 'Submitting...' : 'Saving...');
    return this._dataService.formCGIUD(this.cgForm.value).pipe(
      map((res) => {
        this.ams.closeDialog();
        this.ref.markForCheck();
        this._dataService.setFormCCName('');
        return of(res);
      }),
      catchError((err) => {
        this.ams.closeDialog();
        this.ams.showAlert(
          'Error!',
          `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${err.message}`
        );
        this.ref.markForCheck();
        return of(err);
      })
    );

    //     .then((response) => {
    //         this.ams.closeDialog();
    //         this.ref.markForCheck();
    //         resolve(response);
    //     })
    //     .catch(error => {
    //         this.ams.closeDialog();
    //         this.ams.showAlert('Error!', `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`);
    //         this.ref.markForCheck();
    //         resolve('error');
    //     });
    // this._dataService.setFormCCName('');
  }

  // Withdraw or Reject or Reassign
  onWithdrawRejectReassign(action) {
    const data: any = {};
    data.formId = this.formData.FormLogInfo.formId;
    data.formLogId = this.formData.FormLogInfo.formLogId;
    data.empId = !this.isInternal
      ? this.formData.userId
      : this.formData.FormLogInfo.empId;
    data.empName = !this.isInternal
      ? 'External Submitter'
      : this.formData.FormLogInfo.empName;
    data.action = action;
    data.orgName = this.formData.OrgInfo.name;
    data.status = this.formData.FormLogInfo.status;
    data.email = '';
    data.userId = this.formData.userId;
    data.empTypeForLog = !this.isInternal
      ? 'External Submitter'
      : this.formData.FormLogInfo.empTypeForLog;
    data.empTitle = !this.isInternal
      ? 'External Submitter'
      : this.formData.FormLogInfo.title;

    this.ams.showApproveReject(
      `Are you sure you want to ${
        action === 'Withdrawn'
          ? 'withdraw'
          : action === 'Rejected'
          ? 'reject'
          : 'reassign to CIT'
      }?`,
      ''
    );
    this.ams.approveReject.afterClosed().subscribe((result) => {
      if (result) {
        data.comment = result.comment;
        this.ams.showLoader(
          ` ${
            action === 'Withdrawn'
              ? 'Withdrawing'
              : action === 'Rejected'
              ? 'Rejecting'
              : 'Reassigning to CIT'
          }...`
        );
        this._dataService.AprroveRejectWithdrawFormCG(data).subscribe({
          next: (data) => {
            this.isShowLeaveDialog = false;
            this.ams.closeDialog();
            this.ams.showAlert(
              'Success!',
              `Successfully ${
                action === 'Withdrawn'
                  ? 'withdrawn'
                  : action === 'Rejected'
                  ? 'rejected'
                  : 'reassigned to CIT'
              }!`
            );
            this.ref.markForCheck();
            let leaving = setTimeout(() => {
              this.toHome();
            }, 5000);
            this.ams.alert.afterClosed().subscribe(() => {
              this.toHome();
              clearTimeout(leaving);
            });
          },
          error: (error) => {
            this.ams.closeDialog();
            this.ams.showAlert(
              'Error!',
              `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
            );
            this.ref.markForCheck();
          },
        });
      }
    });
  }

  onApprove() {
    if (this.cgForm.invalid)
      this.ams.showAlert(
        'Alert',
        'Please complete all required field(s) marked with an *'
      );
    else if (
      this.cgForm.value.TaxExemptAttach.length === 0 ||
      this.cgForm.value.W9Attach.length === 0 ||
      this.cgForm.value.BoDListAttach.length === 0 ||
      this.cgForm.value.BudgetAttach.length === 0
    ) {
      this.ams.showAlert(
        'Alert',
        'Pleasen attach required PDF documents marked with an *'
      );
    } else if (!this.isFilled && this.cgForm.value.isCIWorkflow === 1) {
      this.ams.showAlert(
        'Alert',
        'Please fill missing field(s) on Accounting Distribution!'
      );
    } else if (!this.isADValid && this.cgForm.value.isCIWorkflow === 1) {
      this.ams.showAlert(
        'Alert',
        'Your Accounting Distribution combination is invalid!'
      );
    } else {
      const data: any = {};
      data.formId = this.cgForm.value.formId;
      data.formLogId = this.formData.FormLogInfo.formLogId;
      data.empId = this.formData.FormLogInfo.empId;
      data.empName = this.formData.FormLogInfo.empName;
      data.action = 'Approved';
      data.orgName = this.formData.OrgInfo.name;
      data.status = this.formData.FormLogInfo.status;
      data.email = '';
      data.userId = this.formData.userId;
      data.empTypeForLog = this.formData.FormLogInfo.empTypeForLog;
      data.empTitle = this.formData.FormLogInfo.title;

      this.ams.showApproveReject('Are you sure you want to Approve?', '');
      this.ams.approveReject.afterClosed().subscribe((result) => {
        if (result) {
          this.savingForm(data).subscribe({
            next: (submitted) => {
              if (submitted !== 'error') {
                data.comment = result.comment;
                this.ams.showLoader('Approving...');
                this._dataService.AprroveRejectWithdrawFormCG(data).subscribe({
                  next: (data) => {
                    this.isShowLeaveDialog = false;
                    if (data === 'ALREADYDONE') {
                      this.ams.closeDialog();
                      this.ams.showAlert(
                        'Error!',
                        'This request has already been approved!'
                      );
                    } else {
                      this.ams.closeDialog();
                      this.ams.showAlert('Success!', 'Successfully approved!');
                    }
                    this.ref.markForCheck();
                    let leaving = setTimeout(() => {
                      this.toHome();
                    }, 5000);
                    this.ams.alert.afterClosed().subscribe(() => {
                      this.toHome();
                      clearTimeout(leaving);
                    });
                  },
                  error: (error) => {
                    this.ams.closeDialog();
                    this.ams.showAlert(
                      'Error!',
                      `Please contact contributions@lge-ku.com with questions. \n Stack trace: ${error.message}`
                    );
                    this.ref.markForCheck();
                  },
                });
              }
            },
          });
        }
      });
    }
  }
  // cancel form
  onCancel() {
    this.toHome();
  }

  toHome() {
    const previousUrl = this.previousRouteService.getPreviousUrl();
    if (previousUrl?.includes('admin')) {
      this.router.navigate([previousUrl]);
    } else {
      this.router.navigate(['']);
    }
  }
  // Subscribe to state data and mark it for changes
  private startSubscriptions(): void {
    this.pendingSubscription = this.pending$.subscribe((data) => {
      this.pending = data;
      this.displayLoader(this.pending);
      this.ref.markForCheck();
    });
    this.errorSubscription = this.error$.subscribe((data) => {
      this.error = data;
      this.ref.markForCheck();
    });

    if (!this.isInternal) {
      this.profileDataSubscription = this.profileData$.subscribe((data) => {
        this.profileData = data;
        this.ref.markForCheck();
      });
    }
    this.stateDataSubscription = this.stateData$.subscribe((data) => {
      this.formData = JSON.parse(JSON.stringify(data));
      console.log(this.formData);
      if (
        !this.isInternal &&
        this.profileData.externalUser.email !== 'minh.vu@lge-ku.com' &&
        this.profileData.externalUser.email.toLowerCase() !==
          this.formData.userId
      ) {
        this.toHome();
      }
      if (
        !this.isInternal &&
        this.isFormExpired &&
        this.formData.statusId === 2
      ) {
        this.ams.showAlert(
          'Expired',
          'Community Grants Application has been expired!'
        );
        this.ref.markForCheck();
      }
      this.formData.serviceArea =
        this.formData.serviceArea === ''
          ? []
          : this.formData.serviceArea.split('|');
      this.formData.fundSrc =
        this.formData.fundSrc === '' ? [] : this.formData.fundSrc.split('|');
      const AddLength = this.formData.AddAttach.length;
      for (let i = 0; i < AddLength; i++) {
        (<FormArray>this.cgForm.controls['AddAttach']).push(
          this.createAttachment('NA', '', '', '0', 'AddAttach')
        );
      }
      // init W9Array
      if (this.formData.W9Attach.length > 0) {
        (<FormArray>this.cgForm.get('W9Attach')).push(
          this.createAttachment('NA', '', '', '0', 'W9Attach')
        );
      }

      if (this.formData.TaxExemptAttach.length > 0) {
        (<FormArray>this.cgForm.get('TaxExemptAttach')).push(
          this.createAttachment('NA', '', '', '0', 'TaxExemptAttach')
        );
      }

      if (this.formData.BoDListAttach.length > 0) {
        (<FormArray>this.cgForm.get('BoDListAttach')).push(
          this.createAttachment('NA', '', '', '0', 'BoDListAttach')
        );
      }

      if (this.formData.BudgetAttach.length > 0) {
        (<FormArray>this.cgForm.get('BudgetAttach')).push(
          this.createAttachment('NA', '', '', '0', 'BudgetAttach')
        );
      }

      if (this.formData.statusId === 9 || this.formData.statusId === 23) {
        this.cgForm.get('amount').setValidators([Validators.required]);
        this.cgForm.get('amount').updateValueAndValidity();
      } else if (
        this.formData.statusId !== 3 &&
        this.formData.statusId !== 11
      ) {
        this.isValidatingRow = false;
      }
      this.cgForm.setValue(this.formData);
      _.each(this.formData.fundSrc, (item) => {
        let ctrl = this.getFundSrcControlName(item);
        if (item !== 'None of These' && ctrl !== '') {
          this.cgForm.get(ctrl).setValidators([Validators.required]);
          this.cgForm.get(ctrl).updateValueAndValidity();
        }
      });

      this.signaturePad.fromDataURL(
        this.cgForm.get(['AuthorizedRep', 'signature']).value
      );
      // populate Auth Representative Sign date as Today with new or drafted form
      if (this.cgForm.get('statusId').value === 2) {
        this.cgForm
          .get(['AuthorizedRep', 'date'])
          .setValue(moment().format('MM/DD/YYYY'));
      } else {
        const signDate = this.cgForm.get(['AuthorizedRep', 'date']).value;
        this.cgForm
          .get(['AuthorizedRep', 'date'])
          .setValue(moment(new Date(signDate)).format('MM/DD/YYYY'));
        this.signaturePad.off();
      }
      switch (this.formData.statusId) {
        case ExternalStatus.Submitted: //Submitted
          // this.atOeBs = false;
          this.isReadOnly = !this.hasRole('ADMIN');
          this.isShowSaveAsDraft = false;
          break;
        case ExternalStatus.Draft: //Draft
          this.isShowSaveAsDraft =
            (!this.isInternal && !this.isReadOnly) || this.hasRole('DEV');
          this.isShowLeaveDialog =
            (!this.isInternal && !this.isReadOnly) || this.hasRole('DEV');
          break;
        case ExternalStatus.Submitted_Approved: // Approved
          // this.atOeBs = false;
          this.isReadOnly = !this.hasRole('ADMIN');
          this.isShowLeaveDialog = this.hasRole('ADMIN');
          this.isShowAccDist = this.hasRole('ADMIN');
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isAwardedAmount = this.hasRole(
            'ADMIN|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
          );
          this.isAccDistEditable = this.hasRole('ADMIN');
          break;
        case 7: //Pending CR&CA Approval
          // this.atOeBs = true;
          this.isReadOnly = !this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowLeaveDialog = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowReassignBtn = this.hasRole('FOUNDATIONAPPROVER');
          this.isShowApproveBtn =
            this.hasRole('FOUNDATIONAPPROVER') &&
            this.permissionsService.getUserId() ===
              this.formData.FormLogInfo.empId;
          this.isShowWithdrawBtn = !this.isInternal;
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isTaxExemptEditable = this.hasRole('ADMIN');
          this.isAwardedAmount = this.hasRole(
            'ADMIN|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
          );
          break;
        case 8: //Pending CCC Review
          // this.atOeBs = true;
          this.isReadOnly = !this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowLeaveDialog = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowReassignBtn = this.hasRole('FOUNDATIONAPPROVER');
          this.isShowApproveBtn =
            this.hasRole('FOUNDATIONAPPROVER') &&
            this.permissionsService.getUserId() ===
              this.formData.FormLogInfo.empId;
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isTaxExemptEditable = this.hasRole('ADMIN');
          this.isShowWithdrawBtn = !this.isInternal;
          this.isAwardedAmount = this.hasRole(
            'ADMIN|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
          );
          break;
        case 9: //Pending Foundation Board of Directors Review
          // this.atOeBs = true;
          this.isReadOnly = !this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowLeaveDialog = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowApproveBtn = this.hasRole('FOUNDATIONAPPROVER');
          this.isShowAccDist = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isTaxExemptEditable = this.hasRole('ADMIN');
          this.isAwardedAmount = this.hasRole(
            'ADMIN|FOUNDATIONAPPROVER|FOUNDATIONREVIEWER'
          );
          this.isAccDistEditable = this.hasRole('ADMIN|FOUNDATIONAPPROVER');
          this.isShowWithdrawBtn = !this.isInternal;
          break;
        case 11:
          this.isReadOnly = !this.hasRole('ADMIN');
          this.isShowLeaveDialog = this.hasRole('ADMIN');
          this.isShowAccDist = this.hasRole('ADMIN');
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isAwardedAmount = true;
          this.isAccDistEditable = this.hasRole('ADMIN');
          break;
        case 23: // pending CIT review
          this.isReadOnly = !this.hasRole('ADMIN|CITAPPROVER');
          this.isShowLeaveDialog = this.hasRole('ADMIN|CITAPPROVER');
          this.isAccDistEditable = this.hasRole('ADMIN|CITAPPROVER');
          this.isShowAccDist = this.hasRole('ADMIN|CITAPPROVER');
          this.isShowApproveBtn = this.hasRole('CITAPPROVER');
          this.isShowSaveButton = this.hasRole('ADMIN');
          this.isAwardedAmount = this.hasRole('ADMIN|CITAPPROVER|CITREVIEWER');
          this.isShowWithdrawBtn = !this.isInternal;
          this.isTaxExemptEditable = this.hasRole('ADMIN');
          this.isShowSaveAsDraft = false;
          break;
        default:
          this.isReadOnly = true;
          this.isShowLeaveDialog = false;
          this.isShowSaveAsDraft = false;
          this.isAwardedAmount = true;
          this.isAwardedAmountEditable = false;
          break;
      }
    });
  }
  // Unsubscribe from state data changes
  private endSubscriptions(): void {
    this.pendingSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
    this.stateDataSubscription.unsubscribe();
    if (!this.isInternal) this.profileDataSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.endSubscriptions();
    this.store.dispatch(new CommunityGrantAction.LoadInitialState());
  }
}
